import React from "react";
import { CheckCircle, Building2, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";

const features = [
  "Three-level underground parking system",
  "Optimized for high vehicle volume in tight spaces",
  "Independent vehicle access without moving others",
  "Ideal balance between depth and cost-efficiency",
  "Robust steel platforms with automated control system",
];

const applications = [
  "Urban Residential Societies",
  "High-Footfall Hospitals",
  "Shopping Complex Basements",
  "Business Parks",
  "Smart City Infrastructure",
];

const ThreeLevelPitParkingDetail = () => {
    const navigate = useNavigate()
  return (
    <section className="about-wrapper">
      {/* Hero */}
      <div className="about-hero">
        <div className="hero-content">
          <h1>3 Level Pit Parking System</h1>
          <p>
            A smart underground parking system that vertically stacks cars in three levels below ground — optimizing space without compromising convenience or safety.
          </p>
        </div>
      </div>

      {/* Description */}
      <div className="about-section">
        <h2>What is 3 Level Pit Parking?</h2>
        <p>
          3 Level Pit Parking is a semi-automatic underground solution designed to stack vehicles on three tiers vertically beneath the surface. It is ideal for buildings where surface area is limited but basement construction is feasible.
        </p>
        <p>
          With this configuration, multiple cars can be parked independently, and each vehicle is retrievable without disturbing others. The system operates with a smart combination of vertical lifts and horizontal sliders for efficient management.
        </p>
      </div>

      {/* Features */}
      <div className="about-section">
        <h2>Key Features & Benefits</h2>
        <ul className="lt-puzzle-list">
          {features.map((item, index) => (
            <li key={index}><CheckCircle size={18} /> {item}</li>
          ))}
        </ul>
      </div>

      {/* How it Works */}
      <div className="about-section">
        <h2>How It Works</h2>
        <p>
          Cars are parked on platforms that descend into a three-level pit using a hydraulic or motorized lift system. Vehicles can be selected using a control interface, and the system automatically raises or shifts the platform to deliver the car at ground level.
        </p>
        <p>
          Advanced sensors, logic controllers, and safety locks ensure secure operations, while surface aesthetics remain undisturbed — making it a practical and elegant parking choice.
        </p>
      </div>

      {/* Applications */}
      <div className="about-section">
        <h2>Best Suited For</h2>
        <ul className="lt-puzzle-list">
          {applications.map((item, index) => (
            <li key={index}><Building2 size={18} /> {item}</li>
          ))}
        </ul>
      </div>

      {/* Call to Action */}
      <div className="lt-puzzle-cta">
        <div className="lt-puzzle-cta-content">
          <h3>Need 3 Level Pit Parking for your property?</h3>
          <p>Contact LIFTECH ENGINEERING PVT. LTD. to unlock maximum underground parking capacity with minimal footprint.</p>
          <button className="lt-puzzle-contact-btn" onClick={() => navigate("/get-started")}>
            <PhoneCall size={18} /> Request Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default ThreeLevelPitParkingDetail;
